import React from "react";
// import { Store } from "../../Store";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Outlet, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import UserProfile from "../User/UserProfile";
import StoreScreen from "../Others/StoreScreen";
import AdminStats from "./AdminStats";
import AdminFinance from "./AdminFinance";
import AdminOrders from "./AdminOrders";
import AdminNotice from "./AdminNotice";
import AdminProducts from "./AdminProducts";
import UserData from "./UserData";
import { Boxes, Bullseye, Cart, People, Router, Wallet2 } from "react-bootstrap-icons";

const AdminScreen = () => {
   //   const { state } = useContext(Store);
   //   const { noticeContent, userInfo, myOrders } = state; // Assuming transactions are part of the state
     const navigate = useNavigate();
     const location = useLocation();
   //   function calculateSalesToday() {
   //     const today = new Date().toISOString().split("T")[0];
   //     return myOrders
   //       .filter((transaction) => transaction.date.split("T")[0] === today)
   //       .reduce((total, transaction) => total + transaction.amount, 0)
   //       .toFixed(2);
   //   }
   
   //   function calculateSalesThisMonth() {
   //     const currentMonth = new Date().getMonth();
   //     return myOrders
   //       .filter(
   //         (transaction) => new Date(transaction.date).getMonth() === currentMonth
   //       )
   //       .reduce((total, transaction) => total + transaction.amount, 0)
   //       .toFixed(2);
   //   }
   
   //   const formContainerStyle = {
   //     display: "flex",
   //     justifyContent: "center",
   //     alignItems: "center",
   //     flex: 1,
   //     flexDirection: "column",
   //     // background: "url('/images/bg2.jpg') center center/cover no-repeat",
   //     minHeight: "40vh",
   //     width: "mx-auto",
   //   };
   
     const RowStyle={
      textTransform: "uppercase", 
      textAlign: "center",
      gap: "15px", 
      alignItems: "center", 
      marginBottom:'20px', 
      marginTop:'10px'
     }

   //   const ColStyle ={
   //    height: "70px", 
   //    width: "100px", 
   //    border: "1px solid black", 
   //    borderRadius: "50%",
   //    color: "#1d0fab",
   //    cursor: "pointer"
   //   }
   const ColStyle = {
      cursor: "pointer",
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom:'10vw',
   };
   
   const ContentStyle = {
      height: "70px",
      width: "100px",
      // padding:'15px',
      // border: "1px solid black",
      // borderRadius: "50%",
      color: "#1d0fab",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column"
    };
  return (
        <Container
          style={{
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "mx-auto",
          }}
        >
         {/* HEADER */}
          <Row>
            <Col>
              <h2
                style={{
                  textTransform: "uppercase",
                  textAlign: "center",
                  color: "#5d0fab",
                  marginTop:'0.3rem'
                }}
              >
                ADMIN DASHBOARD
              <Button size='sm' variant="danger" className="float-end" onClick={()=>navigate('/admin')}>Go Home</Button>
              <Button size='sm' variant="info" className="float-end" onClick={()=>navigate('/home')}>Go To User</Button>
              </h2>
              <hr/>
            </Col>
          </Row>

{/* MAIN PAGE */}
{location.pathname === '/admin' && (
   <Container>
      <Row style={RowStyle}>
        <Col style={ColStyle} onClick={() => navigate("/admin/products")}>
        <div style={ContentStyle}>
         <Boxes/><br/>Products
         </div>
         </Col>
        <Col style={ColStyle} onClick={() => navigate("/admin/orders")}>
        <div style={ContentStyle}>
         <Cart/><br/>Orders
         </div>
         </Col>
      </Row>
      <Row style={RowStyle}>
        <Col style={ColStyle} onClick={() => navigate("/admin/finance")}>
        <div style={ContentStyle}>
         <Wallet2/><br/>Topups
         </div>
         </Col>
        <Col style={ColStyle} onClick={() => navigate("/admin/statistics")}>
        <div style={ContentStyle}>
         <Bullseye/><br/>Summary
         </div>
         </Col>
      </Row>
      <Row style={RowStyle}>
        <Col style={ColStyle} onClick={() => navigate("/admin/users")}>
        <div style={ContentStyle}>
         <People/><br/>Users
         </div>
         </Col>
        <Col style={ColStyle} onClick={() => navigate("/admin/extras")}>
        <div style={ContentStyle}>
         <Router/><br/>Other Info
         </div>
         </Col>
      </Row>
      {/* <Row style={RowStyle}>
        <Col style={ColStyle} onClick={() => navigate("/admin/my-transactions")}>Profile</Col>
        <Col style={ColStyle} onClick={() => navigate("/admin/my-transactions")}>Transactions</Col>
        </Row> */}
</Container>
        )}
      {/* <Row style={RowStyle}>
        <Col style={{ height: "70px", width: "100px", border: "1px solidrgb(180, 12, 110)", color: "#a83803" }}>
          Sales today 
        </Col>
        <Col style={{ height: "70px", width: "100px", border: "1px solid black", color: "#5d0fab" }}>
          Sales this month 
        </Col>
      </Row> */}

{/* ROUTES */}
         <Container fluid>
         <Routes>
            <Route path="/" element={< Outlet/>} />
            <Route path="user-details" element={<UserProfile />} />
            {/* <Route path="my-transactions" element={<TransactionHistory />} /> */}
            {/* <Route path="topup" element={<UserFinance />} /> */}
            <Route path="buy/*" element={<StoreScreen />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="statistics" element={<AdminStats />} />
            <Route path="finance" element={<AdminFinance />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="extras" element={<AdminNotice />} />
            <Route path="users" element={<UserData />} />
         </Routes>
         </Container>
        </Container>
  )
}

export default AdminScreen